export default __webpack_public_path__ + "static/media/elcorteingles.7c0e0b7b.jpg";